import danding from "@/api/danding";
import { formatCategories } from "@/utils/common";
const produce = {
  namespaced: true,
  state: {
    goodsReturnList: [],
    carrierAllList: []
  },
  mutations: {
    setGoodsReturnList(state, data) {
      state.goodsReturnList = data;
    },
    setCarrierAllList(state, data) {
      state.carrierAllList = data;
    }
  },
  actions: {
    queryGoodsReturnList({ commit }, data) {
      return danding.queryGoodsReturnList(data).then(res => {
        commit("setGoodsReturnList", res.result);
        return res;
      });
    },
    importGoodsReturnExcel({ commit }, data) {
      return danding.importGoodsReturnExcel(data).then(res => {
        return res;
      });
    },
    previewGoodsReturnData({ commit }, data) {
      return danding.previewGoodsReturnData(data).then(res => {
        return res;
      });
    },
    cancelGoodsReturn({ commit }, data) {
      return danding.cancelGoodsReturn(data).then(res => {
        return res;
      });
    },
    getGoodsReturnDetail({ commit }, data) {
      return danding.getGoodsReturnDetail(data).then(res => {
        return res;
      });
    },
    finishGoodsReturn({ commit }, data) {
      return danding.finishGoodsReturn(data).then(res => {
        return res;
      });
    },
    submitGoodsReturnOrder({ commit }, data) {
      return danding.submitGoodsReturnOrder(data).then(res => {
        return res;
      });
    },
    exportGoodsReturnOrder({ commit }, data) {
      return danding.exportGoodsReturnOrder(data).then(res => {
        return res;
      });
    },

    // 核放单
    fetchNuclearReleaseList({ commit }, data) {
      return danding.fetchNuclearReleaseList(data).then(res => {
        return res;
      });
    },
    addNuclearReleaseList({ commit }, data) {
      return danding.addNuclearReleaseList(data).then(res => {
        return res;
      });
    },
    closeNuclearRelease({ commit }, data) {
      return danding.closeNuclearRelease(data).then(res => {
        return res;
      });
    },
    enterNuclearReleaseOrder({ commit }, data) {
      return danding.enterNuclearReleaseOrder(data).then(res => {
        return res;
      });
    },
    exportNuclearReleaseList({ commit }, data) {
      return danding.exportNuclearReleaseList(data).then(res => {
        return res;
      });
    },
    fetchNuclearReleaseDetail({ commit }, data) {
      return danding.fetchNuclearReleaseDetail(data).then(res => {
        return res;
      });
    },
    updateNuclearReleaseOrder({ commit }, data) {
      return danding.updateNuclearReleaseOrder(data).then(res => {
        return res;
      });
    },
    fetchCarrierAllList({ commit }, data) {
      return danding.fetchCarrierAllList(data).then(res => {
        commit("setCarrierAllList", res.items);
      });
    },
    exportNuclearReleaseBaseInfo({ commit }, data) {
      return danding.exportNuclearReleaseBaseInfo(data).then(res => {
        return res;
      });
    },
    previewChecklistOrderMailNoImport({ commit }, data) {
      return danding.previewChecklistOrderMailNoImport(data).then(res => {
        return res;
      });
    },
    importChecklistOrderMailNo({ commit }, data) {
      return danding.importChecklistOrderMailNo(data).then(res => {
        return res;
      });
    },
    declareChecklistOrder({ commit }, data) {
      return danding.declareChecklistOrder(data).then(res => {
        return res;
      });
    },
    queryVehicleList({ commit }, data) {
      return danding.queryVehicleList(data).then(res => {
        return res;
      });
    },
    asynSubmitMailNosImport({ commit }, data) {
      return danding.asynSubmitMailNosImport(data).then(res => {
        return res;
      });
    },

    // 核注清单管理
    addEndorsementOrderByChecklistOrderNo({ commit }, data) {
      return danding.addEndorsementOrderByChecklistOrderNo(data).then(res => {
        return res;
      });
    },
    finishEndorsementOrder({ commit }, data) {
      return danding.finishEndorsementOrder(data).then(res => {
        return res;
      });
    },
    getEndorsementDetail({ commit }, data) {
      return danding.getEndorsementDetail(data).then(res => {
        return res;
      });
    },
    nuclearPageQuery({ commit }, data) {
      return danding.nuclearPageQuery(data).then(res => {
        return res;
      });
    },
    editEndorsementOrder({ commit }, data) {
      return danding.editEndorsementOrder(data).then(res => {
        return res;
      });
    },
    batchDownloadEndorsementOrder({ commit }, data) {
      return danding.batchDownloadEndorsementOrder(data).then(res => {
        return res;
      });
    },
    declareEndorsementOrder({ commit }, data) {
      return danding.declareEndorsementOrder(data).then(res => {
        return res;
      });
    },
    orderSplitByChecklistOrderExist({ commit }, data) {
      return danding.orderSplitByChecklistOrderExist(data).then(res => {
        return res;
      });
    },

    // 撤单管理
    cancelLationsPageQuery({ commit }, data) {
      return danding.cancelLationsPageQuery(data).then(res => {
        return res;
      });
    },
    batchDeclareRevokeOrder({ commit }, data) {
      return danding.batchDeclareRevokeOrder(data).then(res => {
        return res;
      });
    },
    batchDeleteRevokeOrder({ commit }, data) {
      return danding.batchDeleteRevokeOrder(data).then(res => {
        return res;
      });
    },
    importRevokeOrder({ commit }, data) {
      return danding.importRevokeOrder(data).then(res => {
        return res;
      });
    },
    previewRevokeOrderImport({ commit }, data) {
      return danding.previewRevokeOrderImport(data).then(res => {
        return res;
      });
    },
    exportRevokeOrder({ commit }, data) {
      return danding.exportRevokeOrder(data).then(res => {
        return res;
      });
    },
    previewMakePurchaseGoods({ commit }, data) {
      return danding.previewMakePurchaseGoods(data).then(res => {
        return res;
      });
    },
    makePurchaseOrder({ commit }, data) {
      return danding.makePurchaseOrder(data).then(res => {
        return res;
      });
    },
    makeReturnDeclareOrder({ commit }, data) {
      return danding.makeReturnDeclareOrder(data).then(res => {
        return res;
      });
    }
  }
};

export default produce;
